export default __webpack_public_path__ + "static/media/kids-coloring-book-now-then-2-image.e5a29a4d.jpg";